import api, { joinApi } from 'utils/api/api';

import { ContactForm, InquiryForm } from 'types/api';
import { Country } from 'types/commons';
import { Job } from 'types/jobs';
import { Jobseeker } from 'types/jobseekers';

import {
  CITIES,
  CONTACT_US,
  COUNTRIES,
  INQUIRY,
  JOBS,
  JOBSEEKERS
} from 'constants/endpoints';

const Services = {
  postContactUs: async (data: ContactForm): Promise<any> => {
    const response = await api.post(CONTACT_US, data);
    return response;
  },

  postInquiry: async (data: InquiryForm): Promise<any> => {
    const response = await api.post(INQUIRY, data);
    return response;
  },

  postJobseeker: async (data: Jobseeker): Promise<void> => {
    await joinApi.post(JOBSEEKERS, data);
  },

  getJobs: async (params: string): Promise<Job[]> => {
    const res = await joinApi.get(`${JOBS}${params}`);
    return res.content;
  },

  getCountries: async (): Promise<Country[]> => {
    const res = await api.get(COUNTRIES);
    return res;
  },

  getCitiesByCountryCodeAndSpelling: async (
    countryCode: string,
    spelling: string
  ): Promise<string[]> => {
    const response = await api.get(
      `${CITIES}?countryCode=${countryCode}&search=${spelling}`,
      {}
    );
    return response;
  }
};

export default Services;
